import React, {
  useContext,
} from 'react';
import noop from 'lodash/noop';
import {
  isNilOrZero,
} from '@populateui/utils';
import clsx from 'clsx';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import {
  statusColorClasses,
} from 'pages/Dashboard/pages/Todos/components/StatusSelect';
import {
  ToDo,
} from 'types/toDo';
import {
  useSidePanel,
} from 'core/hooks';
import {
  ViewContext,
} from 'pages/Dashboard/contexts/viewContext';

type Props = {
  todo?: ToDo;
};

export default function Todo({ todo }: Props) {
  const { openPanel } = useSidePanel();
  const { isPanel } = useContext(ViewContext);

  return (
    <div
      role="button"
      tabIndex={-1}
      onKeyDown={noop}
      onClick={() => {
        const toDoId = todo?.toDoId ?? 0;
        if (!isNilOrZero(toDoId)) {
          openPanel('todo', { todoId: toDoId }, { canGoBack: isPanel });
        }
      }}
      className="flex w-full justify-between items-center py-2 border-b border-b-gray-200 last:border-b-0 hover:bg-blue-50 hover:text-blue-500"
    >
      <div className="flex gap-2 max-w-fit truncate">
        <span className={clsx(
          'rounded rounded-full !w-4 !h-4',
          statusColorClasses[todo?.currentStatus.transitionName ?? ''],
        )}
        />
        <span className="text-xs font-semibold truncate">
          {todo?.name}
        </span>
      </div>
      <div className="flex gap-1 items-center justify-end min-w-[164px]">
        <span className="text-xs text-gray-500">
          {todo?.formattedDate}
        </span>
        <ChevronRightIcon className="!w-5 !h-5 !text-gray-400" />
      </div>
    </div>
  );
}
